import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SpecialPurchaseCancelOffer = lazyWithPreload(
  () => import('./SpecialPurchaseCancelOffer'),
)
